import { ResetPasswordPage } from "../components"

export default ResetPasswordPage
